module.exports = __webpack_public_path__ + "static/media/field-of-corn.c796a3d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/field-of-corn.jpg
// module id = 858
// module chunks = 0